import { baseApiService } from './base'

export interface FeaturesResponse {
  rcrApps: unknown[]
  eosEnabled: boolean
  pdrEnabled: boolean
  elasticSearchEnabled: boolean
  periodicReviewCustomPropEnabled: boolean
  etmfenabled: boolean
}

export async function getFeatures(): Promise<FeaturesResponse> {
  return baseApiService.fetch<FeaturesResponse>('/api/v1/features')
}
